// Libs
import styled from 'styled-components'

// Comps.
import { Section } from '../Section'
import { H2 } from '../H2'
import { HowItWork } from '../HowItWork'

// Defs
import { HowItWorkItem } from '../HowItWork'

interface Props {
  quote?: string
  items: HowItWorkItem[]
  className?: string
}

// Styles
const Container = styled(Section)`
  .quoteText {
    color: #000000;
    text-align: center;
  }
`

export const HowItWorksSection: React.FC<Props> = (props) => {
  // Props
  const { quote, items, className } = props

  // ..
  return (
    <Container className={`HowItWorksSection ${className || ''}`}>
      <H2 className="quoteText">{quote || ''}</H2>
      <HowItWork items={items} />
    </Container>
  )
}
